export default [
  {
    value: 1,
    label: '通过'
  },
  {
    value: -1,
    label: '不通过'
  }
]
